import { useState } from "react"
import { useIntl } from "react-intl";
import useObjectHelper from "../../Helpers/useObjectHelper";
import { FilteringTypes, Filters } from "./BackofficeSurveys.model";
import { Field } from '../../components/FiltersForm/FiltersForm.model';
import { useAuthorizationDataContext } from "../../Helpers/AuthorizationDataProvider";

export const useBackofficeSurveys = () => {
  const [showCreateSurvey, setShowCreateSurvey] = useState(false);
  const [activeFilters, setActiveFilters] = useState<Filters | null>(null);
	const [showMobileFilters, setShowMobileFilters] = useState(false);
  const intl = useIntl();
	const { arrToOptionList, cleanObj } = useObjectHelper();
	const { isAuthorized } = useAuthorizationDataContext();

  const filterDefaultValues: Record<FilteringTypes, any> = {
		date: undefined,
    surveyType: null,
  };

  const filterFields: Field<Record<FilteringTypes, any>>[] = [{
    label: intl.formatMessage({ id: 'formLabels.surveyType' }),
    name: 'surveyType',
    options: { alternateTranslationPrefix: 'surveyType', optionList: arrToOptionList(['QualityOfMentoringRelationship','QualityOfPlatformFunctionality']) },
    placeholder: intl.formatMessage({id: 'formPlaceholders.surveyType'}),
    type: 'select',
  },
  {
    label: 'date',
    name: 'date',
    type: 'date'
  },
  ];

  const onResetFilters = async (callBack?: () => void) => {
    setActiveFilters({...cleanObj(filterDefaultValues)});
    callBack && callBack();
  };
	
  const onSubmitFilters = async (data: Filters, callBack?: () => void) => {
    const filters: Filters = {
      ...activeFilters,
      ...cleanObj(data)
    };
    setActiveFilters(filters);
    callBack && callBack();
  };

  const toggle = (set: React.Dispatch<React.SetStateAction<boolean>>, value: boolean) => {
    set(!value);
	}

  return {
    filterDefaultValues,
    filterFields,
		isAuthorized,
		onResetFilters,
    onSubmitFilters,
    state: { activeFilters, showCreateSurvey, showMobileFilters },
    toggleCreateSurveyPopup: () => { toggle(setShowCreateSurvey, showCreateSurvey) },
		toggleMobileFilters: () => { toggle(setShowMobileFilters, showMobileFilters) },
  }
}